module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue.516ff5f5.jpg";